import { db } from "@/core/services/FirebaseService";
import {
  collection,
  doc,
  documentId,
  DocumentData,
  getDoc,
  getDocs,
  query,
  where,
} from "firebase/firestore";

/** Ambil dokumen `profiles` untuk banyak uid: 10 uid per query, 10 query paralel. */
export async function fetchProfilesByIds(
  uids: string[]
): Promise<Map<string, DocumentData>> {
  const profiles = new Map<string, DocumentData>();
  const chunks: string[][] = [];
  for (let i = 0; i < uids.length; i += 10) chunks.push(uids.slice(i, i + 10));

  for (let i = 0; i < chunks.length; i += 10) {
    await Promise.all(
      chunks.slice(i, i + 10).map(async (chunk) => {
        try {
          const snapshot = await getDocs(
            query(collection(db, "profiles"), where(documentId(), "in", chunk))
          );
          snapshot.forEach((profileDoc) =>
            profiles.set(profileDoc.id, profileDoc.data())
          );
        } catch (error) {
          // Cadangan bila query "in" ditolak: ambil satu per satu
          await Promise.all(
            chunk.map((uid) =>
              getDoc(doc(db, "profiles", uid))
                .then((profileDoc) => {
                  if (profileDoc.exists()) profiles.set(uid, profileDoc.data());
                })
                .catch(() => null)
            )
          );
        }
      })
    );
  }
  return profiles;
}
